module.exports = __webpack_public_path__ + "static/logo-white.3a57ba46b4088776703ae4e1371d43da.svg";